import { hasLogByBridge } from './base';
import getDeviceInfoSync from '../getDeviceInfoSync';
import getBundleInfo from '../getBundleInfo';
export default class Logger {
    options;
    creator;
    bundleId = '';
    bundleVersion = '';
    componentName = '';
    pageName = 'APP_GENERAL';
    pageParams = {};
    logger = null;
    constructor(options, creator) {
        this.options = options;
        this.creator = creator;
        // if (!window.Logger) {
        //     window.Logger = this;
        // }
    }
    async getLogger() {
        if (this.logger) {
            return this.logger;
        }
        if (!this.options.env) {
            const isDev = __DEV__ || process.env.NODE_ENV !== 'production';
            let envString = 'production';
            if (isDev) {
                envString = 'test';
            }
            else if (getDeviceInfoSync().isOverseas) {
                envString = 'oversea';
            }
            this.options.env = envString;
        }
        this.logger = await this.creator(this.options);
        return this.logger;
    }
    async callLogger(name, ...args) {
        const log = await this.getLogger();
        // @ts-expect-error
        if (log[name]) {
            // @ts-expect-error
            log[name](...args);
        }
    }
    log(fn, type, pageOrAction, params = {}, extra = {}) {
        const key = type === 'PV' ? 'page' : 'action';
        if (type === 'PV' &&
            (extra?.type === 'enter' || extra?.type === 'visible')) {
            this.pageName = pageOrAction;
            this.pageParams = params;
        }
        if (hasLogByBridge(type, pageOrAction, params, extra, this.pageName, this.pageParams)) {
            return;
        }
        return this.callLogger(fn, type, {
            [key]: pageOrAction,
            params,
            ...extra,
        });
    }
    async collect(type, pageOrAction, params = {}, extra = {}) {
        return this.log('collect', type, pageOrAction, params, extra);
    }
    setBundleInfo(pageProps) {
        const bundleInfo = getBundleInfo(pageProps.rootTag);
        this.bundleId = bundleInfo.bundleId || pageProps?.bundleId;
        this.componentName =
            bundleInfo.componentName || pageProps.componentName;
        this.bundleVersion = bundleInfo.version;
    }
    isInTab() {
        return ((this.bundleId === 'profile' && this.componentName === 'profile') ||
            (this.bundleId === 'popular' &&
                this.componentName === 'popular-feed') ||
            this.bundleId === 'KyMessageCenter');
    }
    async sendImmediately(type, pageOrAction, params = {}, extra = {}) {
        return this.log('sendImmediately', type, pageOrAction, params, extra);
    }
    async flush() {
        return this.callLogger('flush');
    }
}
